import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router';

const ChatbotAvatar: React.FC = () => {
  const { id } = useParams();
    const navigate= useNavigate()
  const [name, setName] = useState('');

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handleLogin = () => {
    // Handle login logic here (e.g., API call, routing)
navigate(`/${id}/chatbot`)
    console.log('Logging in with name:', name);
  };

  return (
    <div className="bg-gray-100 h-screen flex items-center justify-center font-sans">
      <div className="bg-white rounded-lg shadow-md p-8 w-96">
        <div className="flex items-center justify-center mb-6">
          <span className="text-2xl font-bold text-blue-500">ChattyHR Bot</span>
        </div>

        <div className="mb-4 text-center">
          <span className="text-lg text-gray-700">Your friendly HR assistant</span>
        </div>

<div className="flex justify-center gap-2">

{/* Select AVatar */}
<div className="avatar">
  <div className="w-24 rounded-full">
    <img src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp" />
  </div>
</div>

</div>

        <div className="mb-6 text-center">
          <button className="text-blue-500 hover:text-blue-700 focus:outline-none">Choose your avatar</button> {/* Updated button text */}
        </div>

        <div className="mb-4">
          <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Your Name</label>
          <input
            type="text"
            id="name"
            className="border border-gray-300 rounded-md px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your name"
            value={name}
            onChange={handleNameChange}
          />
        </div>

        <div className="mb-6">
          <button
            onClick={handleLogin}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-300 transition duration-300"
          >
            Start Chatting {/* Updated button text */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatbotAvatar;